"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
require("./Bar.scss");
function BarNavLink(props) {
    return (React.createElement("li", null,
        React.createElement(react_router_dom_1.Link, __assign({}, props, { className: 'navbar-link' }))));
}
exports.BarNavLink = BarNavLink;
//# sourceMappingURL=BarNavLink.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/BarNavLink.js
// module id = 575
// module chunks = 1